import screenWidthBreakpoints from 'rgs-bootstrap/screen-width-breakpoints';

export const SIZES = [{
	name: 'xs',
	min: -Infinity,
	max: screenWidthBreakpoints.sm - 1,
}, {
	name: 'sm',
	min: screenWidthBreakpoints.sm,
	max: screenWidthBreakpoints.md - 1,
}, {
	name: 'md',
	min: screenWidthBreakpoints.md,
	max: screenWidthBreakpoints.lg - 1,
}, {
	name: 'lg',
	min: screenWidthBreakpoints.lg,
	max: Infinity,
},
{
	name: 'xlg',
	min: screenWidthBreakpoints.xlg,
	max: Infinity,
}];

